import Service from "../../services";

const Event = {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        SET_EVENTS: (state, data) => {
            state.list = data
        }
    },
    actions: {
        setView({
            commit
        }, data) {
            //commit('SET_VIEW', 'needaction')
            return data
        },
        setMyEvents({
            commit
        }, params) {
            return Service.Event.my(params).then(res => {
                // commit('SET_EVENTS', res.data.rows)
                return res
            })
        },
        logout({
            commit
        }) {
            commit('SET_EVENTS', null)
        }
    },
}

export default Event
